import { Box, Typography } from "@material-ui/core";
import React from "react";
import clsx from "clsx";
import {
  RECOMMENDED_FLIGHT_LIST_SEPARATOR_PRIMARY_TEXT,
  RECOMMENDED_FLIGHT_LIST_SEPARATOR_SECONDARY_TEXT,
} from "../FlightListInfo/textConstants";
import { FlightListInfo, IFlightListInfoProps } from "../FlightListInfo";

export interface RecommendedFlightInfoProps
  extends Omit<
    IFlightListInfoProps,
    | "flight"
    | "flights"
    | "selectedFareId"
    | "selectedFare"
    | "slice"
    | "index"
    | "recommendedFlight"
    | "showListView"
  > {
  flight: any;
  flights: any;
  selectedFareId: string;
}

export const RecommendedFlightInfo = ({
  flight,
  flights,
  selectedFareId,
  expandedFlight,
  fareClassFilter,
  maxPriceFilter,
  isOutgoing,
  packagesByOutboundFareSlice,
  packagesByReturnFareSlice,
  departureDate,
  returnDate,
  hotelShopDateRange,
  isTripDetailsLoading,
  openMobileFlightDetailsModal,
  airports,
  rewardsKey,
  isAgentPortal,
  largestValueAccount,
  expandedFareDetails,
  handleClickAlgomerchTag,
  setOpenModal,
  handleSliceSelect,
  setClickedFareId,
  setExpandedFlight,
  handleFareSelect,
  setOpenMobileFlightDetailsModal,
}: RecommendedFlightInfoProps) => {
  if (!flight) {
    return null;
  }
  const flightSliceId = flight.slice;
  const flightSlice = flights?.slices[flightSliceId];
  if (!flightSlice) {
    return null;
  }

  const selectedFare =
    flight.fares.find((fare: any) => fare.example?.fare === selectedFareId) ||
    flight.fares[0];

  return (
    <>
      <FlightListInfo
        selectedFare={selectedFare}
        showListView
        slice={flightSlice}
        flight={flight}
        index={0}
        recommendedFlight
        flights={flights}
        selectedFareId={selectedFareId}
        expandedFlight={expandedFlight}
        fareClassFilter={fareClassFilter}
        maxPriceFilter={maxPriceFilter}
        isOutgoing={isOutgoing}
        packagesByOutboundFareSlice={packagesByOutboundFareSlice}
        packagesByReturnFareSlice={packagesByReturnFareSlice}
        departureDate={departureDate}
        returnDate={returnDate}
        hotelShopDateRange={hotelShopDateRange}
        isTripDetailsLoading={isTripDetailsLoading}
        openMobileFlightDetailsModal={openMobileFlightDetailsModal}
        airports={airports}
        rewardsKey={rewardsKey}
        isAgentPortal={isAgentPortal}
        largestValueAccount={largestValueAccount}
        expandedFareDetails={expandedFareDetails}
        handleClickAlgomerchTag={handleClickAlgomerchTag}
        setOpenModal={setOpenModal}
        handleSliceSelect={handleSliceSelect}
        setClickedFareId={setClickedFareId}
        setExpandedFlight={setExpandedFlight}
        handleFareSelect={handleFareSelect}
        setOpenMobileFlightDetailsModal={setOpenMobileFlightDetailsModal}
      />
      {/* TODO: Move this to components, make common */}
      <Box className={clsx("recommended-flight-list-separator")}>
        <Box className="recommended-flight-list-separator-top-row">
          <Box className="dashed-line" />
          <Typography className="recommended-flight-list-separator-primary-text">
            {RECOMMENDED_FLIGHT_LIST_SEPARATOR_PRIMARY_TEXT}
          </Typography>
          <Box className="dashed-line" />
        </Box>
        <Typography className="recommended-flight-list-separator-secondary-text">
          {RECOMMENDED_FLIGHT_LIST_SEPARATOR_SECONDARY_TEXT}
        </Typography>
      </Box>
    </>
  );
};
